import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import cx from 'classnames';
import { Convert, Helpers } from 'src/helpers';
import styles from './_mobileSipTransactionsSuccess.module.scss';

class MobileSipTransactionsSuccess extends Component {
  render() {
    const { checkoutDetail, status, reason, history } = this.props;
    let sipDate = new Date().getDate();
    if (checkoutDetail?.oneClickCheckout?.startDate) {
      const date = checkoutDetail?.oneClickCheckout?.startDate.split('/');
      sipDate = date[0];
    }
    const isSuccess = status === 'success';

    return (
      <div className={styles['mobile-sip-transactions']}>
        <div>
          <div className={styles['banner']}>
            <div className={styles['banner-inner']}>
              <div className={styles['banner-right']}>
                {isSuccess ? (
                  <div className={styles['banner-right-title']}>
                    We have received your request to <br />
                    setup an SIP for
                    <div className={styles['banner-right-title-name']}>
                      {' '}
                      {checkoutDetail?.oneClickCheckout?.fundName}
                    </div>
                  </div>
                ) : (
                  <div>Payment failed</div>
                )}
              </div>
            </div>
          </div>

          <div className={styles['divider']} />

          <div className={styles['amount']}>
            {Convert.toCurrencyValue(checkoutDetail?.oneClickCheckout?.amount || 0)}
            <span>/mo</span>
          </div>

          <div
            className={cx(styles['green-check'], {
              [styles['failed-check']]: !isSuccess,
            })}
          >
            {isSuccess ? (
              <img src="/images/green-check.svg" alt="ok" />
            ) : (
              <img src="/images/failed.png" alt="failed" />
            )}
          </div>

          <div className={styles['date-sip']}>
            {isSuccess ? <>Date of SIP: {Helpers.ordinalSuffix(sipDate)} of every month</> : reason}
          </div>

          {isSuccess && (
            <div className={styles['monthly-title']}>
              Units will be allocated to the 2-3 working days of you investing the amount
            </div>
          )}
        </div>
        <div className={styles['powered-by']}>powered by savvy</div>
        <div className={styles['footer-spacer']} />
        {!isSuccess && (
          <div
            className={cx(styles['footer'], {
              [styles['disabled-footer']]: false,
            })}
          >
            <button onClick={() => history.goBack()} disabled={false}>
              RETRY
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(MobileSipTransactionsSuccess);
